import { ETheme, EThemeBackground } from "@/common/entity/Enum";
import { renderColorPrimary } from "@/common/function/FunctionTheme";
import styled from "styled-components";

export const BaseCanvasWrapper = styled.div<{ $isOpen?: boolean, $theme?: string }>`
  margin-top: 4px;
  margin-bottom: 4px;
  background-color: ${props => props.$theme === ETheme.Dark ? "rgb(0 0 0)" : "rgb(231, 240, 248)" };

  .canvas_panel {
    border-radius: 8px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    position: relative;
    background: ${(props) => props.$theme === ETheme.Dark ? EThemeBackground.Dark : EThemeBackground.Light};
  }

  .roll_animation {
    animation-name: ${(props) => props.$isOpen && "roll"};
    animation-duration: ${(props) => props.$isOpen && "0.25s"};
    animation-delay: ${(props) => props.$isOpen && "0.05s"};
    animation-fill-mode: ${(props) => props.$isOpen && "forwards"};
  }

  .rc_accordionPanel_content {
    transition: ${(props) =>
      props.$isOpen && "max-height 1s ease-in-out, all 1s ease-out"};
    overflow: ${(props) => props.$isOpen && "hidden"};
    margin-left: ${(props) => props.$isOpen && "0px"};
    margin-right: ${(props) => props.$isOpen && "0px"};
  }

  @keyframes roll {
    from {
        transform: rotate(0deg);
    }
  
    to {
        transform: rotate(90deg);
    }
  }
`;

export const HeaderTitleBarWrapper = styled.div`
  width: 100%;
`;

export const TitleGroupWrapper = styled.div<{$theme?: string}>`
  color: ${(props) => renderColorPrimary(props.$theme)};
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  max-width: calc(min(80vw, 90% - 20px));
  text-transform: capitalize;
  font-family: "Segoe UI", "Segoe UI Web (West European)", "Segoe UI",
    -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif !important;
  gap: 5px;
  display: flex;
  flex-flow: inherit;
  align-self: flex-start;
`;

export const ButtonGroupWrapper = styled.div`
  float: right;
  max-width: 50%;
  flex: 10;
  display: flex;

  &:last-child {
    margin-right: 8px;
  }
`;

export const ButtonWrapper = styled.div`
  margin-right: 4px;
`;
